import React from 'react';
import { ChefHat, Flame, Award, Heart, TreePine, PartyPopper } from 'lucide-react';

const features = [
  { icon: <ChefHat size={32} />, title: 'Master Chefs', desc: 'Our culinary team brings decades of experience crafting unforgettable dishes.' },
  { icon: <Flame size={32} />, title: 'Fresh Ingredients', desc: 'Locally sourced, premium quality ingredients in every single dish we serve.' },
  { icon: <Award size={32} />, title: 'Award Winning', desc: 'Recognized as Seguku\'s premier dining destination for authentic cuisine.' },
  { icon: <Heart size={32} />, title: 'Made with Love', desc: 'Every dish is prepared with passion, care, and attention to detail.' },
  { icon: <TreePine size={32} />, title: 'Outdoor Seating', desc: 'Beautiful garden setting perfect for enjoying Uganda\'s pleasant weather.' },
  { icon: <PartyPopper size={32} />, title: 'Private Events', desc: 'Host your celebrations in our exclusive private dining spaces.' },
];

const WhyChooseUs = () => (
  <section className="section-padding" style={{ backgroundColor: '#1A1A1A' }}>
    <div className="container">
      <div className="text-center mb-5 reveal">
        <span className="section-subtitle">Why Syra</span>
        <h2 className="text-white" style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
          Why Choose Us
        </h2>
        <div className="gold-divider-center"></div>
      </div>

      <div className="row g-4">
        {features.map((item, index) => (
          <div key={index} className="col-md-6 col-lg-4 reveal" style={{ transitionDelay: `${index * 0.1}s` }}>
            <div className="text-center p-4 h-100" style={{
              borderRadius: '16px',
              border: '1px solid rgba(212, 175, 55, 0.15)',
              backgroundColor: 'rgba(255,255,255,0.03)',
              transition: 'all 0.3s ease',
            }}>
              <div className="mb-3 d-inline-flex align-items-center justify-content-center"
                style={{ width: '70px', height: '70px', borderRadius: '50%', backgroundColor: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37' }}>
                {item.icon}
              </div>
              <h5 className="text-white mb-3" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600 }}>
                {item.title}
              </h5>
              <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', lineHeight: 1.8 }}>
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
